
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import { mapGetters } from 'vuex';


export default {

components: {
Tabbar,
TabbarItem,
},
data() {
return {
mine: {
path: '/mine/index',
replace: true,
},
hall: {
path: '/hall',
replace: true,
},
tender: {
path: '/tendering',
replace: true,
},
tenderL: {
path: '/tenderingL',
replace: true,
},
};
},
watch: {
lowerPage() {
this.$nextTick(() => {
this.$store.commit('updateLowerPage', this.selected);
});
},
upperPage() {
this.$nextTick(() => {
this.$store.commit('updateUpperPage', this.selected);
});
},
$route() {
this.$store.commit('updateLowerPage', this.selected);
this.$store.commit('updateUpperPage', this.selected);
}
},

computed: {
upperPage: {
get() {
return this.$store.state.upperPage;
},
set(val) {
this.$store.commit('updateUpperPage', val);
}
},
lowerPage: {
get() {
return this.$store.state.lowerPage;
},
set(val) {
this.$store.commit('updateLowerPage', val);
}
},
...mapGetters([
'isLower',
'isUpper',
]),
selected() {
const path = this.$route.path.split('/')[1];

if (this.isUpper) {
switch (path) {
case 'tendering':
return 0;
case 'mine':
return 1;
default:
return 1;
}
}

switch (path) {
case 'hall':
return 0;
case 'tenderingL':
return 1;
case 'mine':
return 2;
default:
return 2;
}
}
},
};
